import React from "react";
import { Col, Row, Form, Input, Button, message } from "antd";
import { template } from "@reco-m/core";
import { Namespaces } from "@reco-w/office-models";
import { ViewComponent } from "@reco-w/core-ui";
import { createFlow, formDataReplace } from "./flowbind";
import Modal from "antd/lib/modal/Modal";
import { CloseOutlined } from "@ant-design/icons";

export namespace Consulting {
    export interface IProps extends ViewComponent.IProps {
        formItemLayout?: any;
        isModal?: boolean;
        modalCancel: () => void;
        renderType?: number
        orderCode: string
    }

    export interface IState extends ViewComponent.IState { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.office;
        swiper;
        tabSetChang(e) {
            this.dispatch({ type: "input", data: { index: e + 1 } });
        }

        componentDidMount() { }

        subimt() {
            const { state } = this.props,
                name = state!.name,
                company = state!.company,
                zw = state!.zw,
                tel = state!.tel;

            if (!name) {
                message.error("姓名不能为空");
                return;
            }
            if (!company) {
                message.error("企业名称不能为空");
                return;
            }
            if (!tel) {
                message.error("电话不能为空");
                return;
            }
            if (tel.length !== 11) {
                message.error("电话格式不正确");
                return;
            }
            // if (!zw) {
            //     message.error("职位不能为空");
            //     return;
            // }
            message.loading('提交中', 100000)

            createFlow(this.props.orderCode || 'guanwqysy', (_flowProject, projectContent) => {
                formDataReplace(projectContent, "91ce85b8-4c1a-412c-a546-bad020902ba7", name);
                formDataReplace(projectContent, "dafe513c-d5d5-4183-b382-01e3236cb58c", company);
                formDataReplace(projectContent, "3b3f895f-d856-4532-a288-5a515b6b559f", tel);
                formDataReplace(projectContent, "20d39dcb-f9d4-4f92-85d3-c77c3673c796", zw);
                return {
                    order: {
                        // bindTableName: "parkHelper",
                        contactPerson: name,
                        contactMobile: tel,
                        inputerMobile: tel,
                        parkId: "801955773415604",
                        parkName: "瑞谷云企",
                    },
                    state: {
                        componentData: JSON.stringify(projectContent),
                    },
                };
            }).then(() => {
                message.destroy()
                message.info("提交成功，提交需求申请后，15分钟内有专属客服联系您");
                this.dispatch({ type: "input", data: { name: "", company: "", tel: "", zw: "" } });
            });

            this.props.modalCancel && this.props.modalCancel();
        }

        renderModal() {
            const { state } = this.props;

            return (
                <Modal
                    open={true}
                    footer={null}
                    width={850}
                    centered={true}
                    onCancel={this.props.modalCancel}
                    closeIcon={<CloseOutlined className="size-32" style={{ color: "#ff6a00" }} />}
                >
                    <div className="details-panel pt20">
                        <div className="title pb20">我要咨询</div>
                    </div>
                    <Form size="large" className="large-labe pt30" style={{ margin: "0 50px" }}>
                        <Row gutter={[60, 30]}>
                            <Col xs={24} lg={12} xxl={12}>
                                <Form.Item label={<span>姓&emsp;&emsp;名</span>} required={true}>
                                    <Input
                                        value={state!.name}
                                        onChange={(e) => {
                                            this.dispatch({ type: "input", data: { name: e.currentTarget.value } });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={12} xxl={12}>
                                <Form.Item label={`企业名称`} required={true}>
                                    <Input
                                        value={state!.company}
                                        onChange={(e) => {
                                            this.dispatch({ type: "input", data: { company: e.currentTarget.value } });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={12} xxl={12}>
                                <Form.Item label={<span>电&emsp;&emsp;话</span>} required={true}>
                                    <Input
                                        value={state!.tel}
                                        onChange={(e) => {
                                            this.dispatch({ type: "input", data: { tel: e.currentTarget.value } });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={12} xxl={12}>
                                <Form.Item label={<span>职&emsp;&emsp;位</span>} >
                                    <Input
                                        value={state!.zw}
                                        onChange={(e) => {
                                            this.dispatch({ type: "input", data: { zw: e.currentTarget.value } });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span="24">
                                <div className="primary-color text-center form-tips">提交需求申请后，15分钟内有专属客服联系您!</div>
                            </Col>
                            <Col span="24">
                                <div className="text-center form-button">
                                    <Button
                                        style={{ width: 120 }}
                                        type="primary"
                                        htmlType="submit"
                                        onClick={() => {
                                            this.subimt();
                                        }}
                                    >
                                        提交
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            );
        }

        render(): React.ReactNode {
            const {
                formItemLayout = {
                    labelCol: {
                        span: 5,
                    },
                    wrapperCol: {
                        span: 19,
                    },
                },
                state,
                isModal,
                renderType
            } = this.props;

            if (isModal) return this.renderModal();

            if (renderType == 1) {
                return <div className="block-content consult-content">
                    <div className="container">
                        <div className="second-title line-no white-color">
                            <span>立即咨询定制方案</span>
                        </div>
                        <div className="consult-form">
                            <div className="consult-form-item">
                                <Input placeholder="请输入您的姓名" value={state!.name}
                                    onChange={(e) => {
                                        this.dispatch({ type: "input", data: { name: e.currentTarget.value } });
                                    }} />
                            </div>
                            <div className="consult-form-item">
                                <Input placeholder="请输入您的单位" value={state!.company}
                                    onChange={(e) => {
                                        this.dispatch({ type: "input", data: { company: e.currentTarget.value } });
                                    }} />
                            </div>
                            <div className="consult-form-item">
                                <Input placeholder="请输入您的联系方式" value={state!.tel}
                                    onChange={(e) => {
                                        this.dispatch({ type: "input", data: { tel: e.currentTarget.value } });
                                    }} />
                            </div>

                            <div className="consult-form-item">
                                <Input placeholder="请输入您的职位"
                                    value={state!.zw}
                                    onChange={(e) => {
                                        this.dispatch({ type: "input", data: { zw: e.currentTarget.value } });
                                    }} />
                            </div>
                            <div className="consult-form-item">
                                <Button type="primary" ghost block shape="round" onClick={this.subimt.bind(this)}>立即咨询</Button>
                            </div>
                        </div>
                    </div>
                </div>
            }

            return (
                <div className="details-panel newbg">
                    <div className={"title"}>我要咨询</div>
                    <div className={"container"}>
                        <div className="desc">
                            <Form size={"large"} {...formItemLayout}>
                                <Row gutter={[15, 15]}>
                                    <Col xs={24} lg={10} xxl={10}>
                                        <Form.Item label={<span>姓&emsp;&emsp;名</span>} required={true}>
                                            <Input
                                                value={state!.name}
                                                onChange={(e) => {
                                                    this.dispatch({ type: "input", data: { name: e.currentTarget.value } });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} lg={14} xxl={14}>
                                        <Form.Item label={`企业名称`} required={true}>
                                            <Input
                                                value={state!.company}
                                                onChange={(e) => {
                                                    this.dispatch({ type: "input", data: { company: e.currentTarget.value } });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} lg={10} xxl={10}>
                                        <Form.Item label={<span>电&emsp;&emsp;话</span>} required={true}>
                                            <Input
                                                value={state!.tel}
                                                onChange={(e) => {
                                                    this.dispatch({ type: "input", data: { tel: e.currentTarget.value } });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} lg={14} xxl={14}>
                                        <Form.Item label={<span>职&emsp;&emsp;位</span>} >
                                            <Input
                                                value={state!.zw}
                                                onChange={(e) => {
                                                    this.dispatch({ type: "input", data: { zw: e.currentTarget.value } });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div className="highlight-color text-center">提交需求申请后，15分钟内有专属客服联系您</div>
                        <div className="text-center">
                            <Button className="hig-btn" type={"primary"} onClick={this.subimt.bind(this)}>
                                提交
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.office]);
}
